import Application from '../Application';
import BaseView, { DomainModel3D } from './BaseView';
import logging from '../logging';
import pc from '../ParametricCache';
import { Mesh, BufferGeometry, Material } from 'three';
import { VerticalPanel } from '../domain';

const log = logging('view');

export default class VerticalPanelView extends BaseView {

    declare model: VerticalPanel;

    mesh: Mesh;

    highlights: Set<Mesh> = new Set();

    constructor(model: DomainModel3D, app: Application) {
        super(model, app);
        this.init();
    }

    async make() {

        this.userData.isParametric = true;
        this.name = 'VerticalPanel';

        this.mesh = new Mesh(new BufferGeometry(), new Material());
        this.mesh.castShadow = true;
        this.mesh.receiveShadow = true;
        this.add(this.mesh);
    }

    protected bind(): void {
        this.changeSize = this.changeSize.bind(this);
        this.model.bind('width', this.changeSize);
        this.model.on('depth', this.changeSize);

        this.model.bind('thickness', () => {
            const scale = this.model.thickness / 0.75;
            this.mesh.scale.set(scale, 1, 1);
        });

        this.bindMaterial(this.mesh, this.model.material);
    }

    private changeSize() {
        this.updates.queue(
            async () => {
                let geometry = await pc.make(
                    'VerticalBoringPanel', 
                    'boring_panel_half',
                    this.model.height,
                    this.model.depth,
                    this.model.mirror,
                );
                return geometry;
            },
            (geo: BufferGeometry) => {
                this.mesh.geometry = geo;
                this.pipelineUpdate();
            }
        );
    }

}
